/**
 * Inmueble (Property) section for CreateSolicitudDialog
 */
import React from 'react';
import { Label } from '../ui/label';
import { Input } from '../ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import GarantiaDisplay from './GarantiaDisplay';
import { ORIGENES } from './useCreateSolicitud';

const InmuebleSection = ({
  formData,
  proyectos,
  subdivisiones,
  selectedProyecto,
  calculandoGarantia,
  onProyectoChange,
  onEtapaChange,
  onOrigenChange,
  onFechaEntregaChange,
  onDepartamentoChange
}) => {
  return (
    <div className="border border-[#E8E8E7] rounded-lg p-3 sm:p-4">
      <h3 className="text-sm sm:text-base lg:text-lg font-semibold text-[#2D2D2D] mb-2 sm:mb-3" style={{ fontFamily: 'Playfair Display, serif' }}>
        Datos del Inmueble
      </h3>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 sm:gap-4">
        {/* Proyecto */}
        <div className="sm:col-span-3">
          <Label className="text-xs sm:text-sm">Proyecto *</Label>
          <Select value={formData.proyecto_id} onValueChange={onProyectoChange} required>
            <SelectTrigger className="border-[#c5b8a2]" data-testid="proyecto-select">
              <SelectValue placeholder="Seleccionar proyecto" />
            </SelectTrigger>
            <SelectContent>
              {proyectos.map((proy) => (
                <SelectItem key={proy.id} value={proy.id}>
                  {proy.nombre}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>

        {/* Etapa / Torre */}
        <div>
          <Label className="text-xs sm:text-sm">Etapa / Torre *</Label>
          <Select
            value={formData.etapa || (selectedProyecto && !selectedProyecto.tiene_subdivision ? "sin_etapas" : "")}
            onValueChange={onEtapaChange}
            disabled={!selectedProyecto || (!selectedProyecto.tiene_subdivision && (!selectedProyecto.etapas || selectedProyecto.etapas.length === 0))}
            required
          >
            <SelectTrigger className="border-[#c5b8a2] text-sm" data-testid="etapa-select">
              <SelectValue placeholder={!selectedProyecto ? "Seleccionar proyecto primero" : (selectedProyecto.tiene_subdivision ? "Seleccionar subdivisión" : "Sin etapas")} />
            </SelectTrigger>
            <SelectContent>
              {selectedProyecto?.tiene_subdivision ? (
                subdivisiones.length > 0 ? (
                  subdivisiones.map((sub) => (
                    <SelectItem key={sub.id} value={sub.nombre}>
                      {sub.nombre}
                    </SelectItem>
                  ))
                ) : (
                  <SelectItem value="sin_subdivisiones" disabled>
                    No hay subdivisiones registradas
                  </SelectItem>
                )
              ) : (
                selectedProyecto?.etapas?.length > 0 ? (
                  selectedProyecto.etapas.map((etapa) => (
                    <SelectItem key={etapa} value={etapa}>
                      {etapa}
                    </SelectItem>
                  ))
                ) : (
                  <SelectItem value="sin_etapas">Sin etapas</SelectItem>
                )
              )}
            </SelectContent>
          </Select>
        </div>

        {/* Departamento */}
        <div className="sm:col-span-2">
          <Label className="text-xs sm:text-sm">Número de Departamento *</Label>
          <Input
            value={formData.departamento}
            onChange={(e) => onDepartamentoChange(e.target.value)}
            className="border-[#c5b8a2] text-sm"
            placeholder="Ej: 201"
            required
            data-testid="departamento-input"
          />
        </div>

        {/* Origen */}
        <div>
          <Label className="text-xs sm:text-sm">Origen *</Label>
          <Select
            value={formData.origen}
            onValueChange={onOrigenChange}
            required
          >
            <SelectTrigger className="border-[#c5b8a2] text-sm" data-testid="origen-select">
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              {ORIGENES.map((origen) => (
                <SelectItem key={origen} value={origen}>
                  {origen}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>

        {/* Fecha de Entrega */}
        <div>
          <Label className="text-xs sm:text-sm">Fecha de Entrega</Label>
          <Input
            type="date"
            value={formData.fecha_entrega}
            onChange={(e) => onFechaEntregaChange(e.target.value)}
            className="border-[#c5b8a2] text-sm"
            data-testid="fecha-entrega-input"
          />
        </div>

        {/* Estados de Garantía */}
        <div className="sm:col-span-2 grid grid-cols-2 gap-3">
          <GarantiaDisplay
            label="Estado Garantía Acabados"
            value={formData.estado_garantia_acabados}
            calculando={calculandoGarantia}
            testId="estado-garantia-acabados"
          />
          <GarantiaDisplay
            label="Estado Garantía Estructural"
            value={formData.estado_garantia_estructural}
            calculando={calculandoGarantia}
            testId="estado-garantia-estructural"
          />
        </div>
      </div>
    </div>
  );
};

export default InmuebleSection;
